import React from "react";
import {Alert, Spinner} from "react-bootstrap";
import FilterBar from "./FilterBar.jsx";

/**
 * Kopf jeder Verkaufsstatistik-Unterseite: Seitentitel, Fehlerhinweis zu den
 * Filteroptionen, Lade-Spinner bis der Zeitraum feststeht, danach die
 * gemeinsame Filterleiste. Nimmt den kompletten Rückgabewert von
 * useSalesFilters() entgegen, damit jede Seite (Überblick, Sortimente,
 * Artikel, Renner & Penner) exakt dieselbe Kopfzeile bekommt und für sich
 * allein benutzbar bleibt.
 */
export default function SalesFilterHeader({title, salesFilters, children}) {
    const {
        filtersMetaError,
        filtersReady,
        filtersMeta,
        preset,
        selectPreset,
        dateFrom,
        dateTo,
        changeDateFrom,
        changeDateTo,
        level,
        setLevel,
        groupOptions,
        articleGroups,
        setArticleGroups,
        searchInput,
        setSearchInput,
    } = salesFilters;

    return (
        <>
            <div className="d-flex align-items-center justify-content-between flex-wrap gap-2 mb-2">
                <h1 className="h4 mb-0">{title}</h1>
            </div>

            {filtersMetaError && <Alert variant="warning">{filtersMetaError}</Alert>}

            {!filtersReady ? (
                <div className="d-flex justify-content-center py-5">
                    <Spinner animation="border" role="status">
                        <span className="visually-hidden">Wird geladen…</span>
                    </Spinner>
                </div>
            ) : (
                <>
                    <FilterBar
                        preset={preset}
                        onPresetSelect={selectPreset}
                        dateFrom={dateFrom}
                        dateTo={dateTo}
                        onDateFromChange={changeDateFrom}
                        onDateToChange={changeDateTo}
                        dateMin={filtersMeta?.date_range?.min}
                        dateMax={filtersMeta?.date_range?.max}
                        sourceRanges={filtersMeta?.source_ranges}
                        level={level}
                        onLevelChange={setLevel}
                        groupOptions={groupOptions}
                        articleGroups={articleGroups}
                        onArticleGroupsChange={setArticleGroups}
                        search={searchInput}
                        onSearchChange={setSearchInput}
                    />
                    {children}
                </>
            )}
        </>
    );
}
